import React from "react";
import PropTypes from "prop-types";
import { FluidSections } from "../FluidSections";
import { SplitContentWrapper } from "@sunwing/wvi-components";

const SplitContentWrapperConnector = ({ data }) => (
	<SplitContentWrapper
		columns={data.columns}
		renderComponent={(component, index) => (
			<FluidSections key={index} data={[component]} useWrapper={false} />
		)}
	/>
);

SplitContentWrapperConnector.propTypes = {
	data: PropTypes.shape({
		columns: PropTypes.arrayOf(
			PropTypes.shape({
				columnSizes: PropTypes.shape({
					mobile: PropTypes.shape({
						isCustom: PropTypes.bool,
						value: PropTypes.string,
					}),
					tablet: PropTypes.shape({
						isCustom: PropTypes.bool,
						value: PropTypes.string,
					}),
					desktop: PropTypes.shape({
						isCustom: PropTypes.bool,
						value: PropTypes.string,
					}),
				}),
				components: PropTypes.arrayOf(PropTypes.object),
			})
		),
	}),
};

SplitContentWrapperConnector.defaultProps = {
	data: null,
};

export { SplitContentWrapperConnector };
